import React from 'react';
import { Icon } from 'ensightful-koala-ui';
import styled from 'styled-components';

import { ButtonText } from 'components/atoms/Text';

const ButtonContainer = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 6px;
    height: 32px;
    padding-left: 14px;
    padding-right: 14px;
    background-color: white;

    & > * {
        margin: 0;
    }

    &:hover {
        cursor: pointer;
        ${(props) =>
            props.active ? 'box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.03)' : ''};
        border-radius: 6px;
    }

    & svg path {
        fill: ${(props) => props.color};
    }

    &:disabled {
        cursor: default;
    }
`;

const StyledButtonText = styled(ButtonText)`
    margin-left: 6px;
    color: ${(props) => (props.active ? props.color : '#616161')};
    font-weight: bold;
`;

const IconTextButton = ({ text, active = false, kind = 'filter', size = 20, fill, ...props }) => {
    return (
        <ButtonContainer active={active} {...props}>
            <Icon kind={kind} size={size} fill={fill} />
            {text && <StyledButtonText active={active}>{text}</StyledButtonText>}
        </ButtonContainer>
    );
};

export default IconTextButton;
